import React from 'react';
import Icon from 'components/AppIcon';

const REQUIREMENTS = [
  { label: 'At least 8 characters', test: (p) => p?.length >= 8 },
  { label: 'One uppercase letter', test: (p) => /[A-Z]/?.test(p) },
  { label: 'One lowercase letter', test: (p) => /[a-z]/?.test(p) },
  { label: 'One number', test: (p) => /[0-9]/?.test(p) },
  { label: 'One special character', test: (p) => /[^A-Za-z0-9]/?.test(p) },
];

export function getStrength(password) {
  if (!password) return { score: 0, label: '', color: '' };
  const passed = REQUIREMENTS?.filter(r => r?.test(password))?.length;
  if (passed <= 1) return { score: 1, label: 'Weak', color: 'var(--color-error)' };
  if (passed === 2) return { score: 2, label: 'Fair', color: 'var(--color-warning)' };
  if (passed === 3 || passed === 4) return { score: 3, label: 'Strong', color: 'var(--color-success)' };
  return { score: 4, label: 'Very Strong', color: 'var(--color-primary)' };
}

export default function PasswordStrengthMeter({ password }) {
  const strength = getStrength(password);
  if (!password) return null;

  return (
    <div className="space-y-3 mt-2">
      {/* Progress Bar */}
      <div className="space-y-1">
        <div className="flex items-center justify-between">
          <span className="text-xs text-[var(--color-muted-foreground)] font-[var(--font-caption)]">Password strength</span>
          <span className="text-xs font-semibold font-[var(--font-caption)]" style={{ color: strength?.color }}>
            {strength?.label}
          </span>
        </div>
        <div className="flex gap-1">
          {[1, 2, 3, 4]?.map(i => (
            <div
              key={i}
              className="h-1.5 flex-1 rounded-full transition-all duration-300"
              style={{
                backgroundColor: i <= strength?.score ? strength?.color : 'var(--color-border)',
              }}
            />
          ))}
        </div>
      </div>
      {/* Requirements Checklist */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
        {REQUIREMENTS?.map((req, i) => {
          const passed = req?.test(password);
          return (
            <div key={i} className="flex items-center gap-1.5">
              <Icon
                name={passed ? 'CheckCircle' : 'Circle'}
                size={12}
                color={passed ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
              />
              <span className={`text-xs font-[var(--font-caption)] ${
                passed ? 'text-[var(--color-success)]' : 'text-[var(--color-muted-foreground)]'
              }`}>
                {req?.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
